@if (!isLoading) {
  <mr-page
    [headerTemplate]="headerTemplate"
    [showHeaderUnderline]="true"
    kind="setting"
  >
    <ng-template #headerTemplate>
      <img
        width="60"
        src="/assets/images/logo-mr.svg"
        alt="Managed Receiving logo"
      />
      Managed Receiving
    </ng-template>
    <div class="warning">
      <h5>
        Action Required: Please Register Your Account, New and Existing Users
      </h5>
      <p>
        We are updating our system to improve security and enhance your
        experience.
      </p>
      <p>
        As part of this update, new users or users with missing or incomplete
        security information are required to complete a quick registration using
        a custom registration form. This ensures your account meets our latest
        security standards.
      </p>
      <p class="highlighted">
        This is a one-time process and should only take a few minutes.
      </p>
      <p>
        If you have any questions or need assistance, please reach out to
        <a href="mailto:ManagedReceivingSupport@capstonelogistics.com">
          ManagedReceivingSupport&#64;capstonelogistics.com
        </a>
      </p>
    </div>
    <header>
      <h1>Finish Setting Up Your Account</h1>
      <h2>
        We just need a few more things to get your account up and running.
      </h2>
    </header>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <mr-fieldset [disabled]="isLoading">
        <mr-fieldset header="Organization Information" [disabled]="isLoading">
          <mr-textbox
            label="Organization Name"
            formControlName="organizationName"
          ></mr-textbox>
          <mr-dropdown
            label="Organization Type"
            formControlName="organizationType"
            [items]="organizationTypesChanges | async"
            displayProperty="name"
          ></mr-dropdown>
          <mr-fieldset
            [hidden]="(isNumberTypeFieldShownChanges | async) === false"
          >
            <mr-textbox
              label="MC or DOT Number"
              formControlName="mcOrDotNumber"
            ></mr-textbox>
          </mr-fieldset>
          <mr-textbox
            [hidden]="(isJobTitleFieldShownChanges | async) === false"
            label="Job Title"
            formControlName="jobTitle"
          ></mr-textbox>
        </mr-fieldset>
        <mr-fieldset
          header="Organization Contact Information"
          [disabled]="isLoading"
        >
          <mr-phone-number-input
            label="Work Phone Number"
            formControlName="workPhoneNumber"
          ></mr-phone-number-input>
          <mr-textbox
            mrGooglePlace
            label="Street Address"
            formControlName="streetAddress"
          ></mr-textbox>
          <mr-textbox
            label="City"
            formControlName="city"
            [maxlength]="100"
          ></mr-textbox>
          <mr-dropdown
            label="State / Province"
            formControlName="state"
            [items]="statesChanges | async"
          ></mr-dropdown>
          <mr-textbox
            label="Postal Code"
            formControlName="postalCode"
            [maxlength]="10"
          ></mr-textbox>
          <mr-dropdown
            label="Country"
            formControlName="country"
            [items]="countryNamesChanges"
          ></mr-dropdown>
        </mr-fieldset>
        <mr-fieldset header="Comments" [disabled]="isLoading">
          <mr-textarea
            label="Comment"
            description="Use this field to describe your role, position, or job description"
            placeholder="Please assign similar access as ____"
            formControlName="comments"
            [maxlength]="150"
          ></mr-textarea>
        </mr-fieldset>
        <div class="button-group">
          <mr-button type="submit" size="extra-large" [disabled]="!canSubmit"
            >Create Account</mr-button
          >
          <mr-button
            size="extra-large"
            kind="cancel"
            [disabled]="isSubmitting"
            (click)="cancel()"
            >Cancel</mr-button
          >
        </div>
      </mr-fieldset>
    </form>
  </mr-page>
} @else {
  <mr-loading kind="fullscreen"></mr-loading>
}
